<template>
  <article :class="getClass()" :id="'tease-' + item.id">
    <div :class="getImageClass()" v-if="itemStore.showImage">
      <a :href="item.link" aria-hidden="true" tabindex="-1"
        ><img
          v-if="item.image.large"
          :src="item.image.large"
          :alt="item.image.alt"
      /></a>
      <template v-for="key in itemStore.showFields" :key="key">
        <div v-if="key === 'terms'" class="post-term">
          {{ getTerms() }}
        </div>
      </template>
    </div>
    <div class="tease-content">
      <h3 class="post-title">
        <a :href="item.link" v-if="itemStore.hasLink">{{ item.title }}</a>
        <template v-else>{{ item.title }}</template>
      </h3>
      <p class="preview" v-if="itemStore.showPreview">{{ item.preview }}</p>
      <a
        :href="item.link"
        tabindex="-1"
        aria-hidden="true"
        class="tease-link"
        v-if="itemStore.readMore && itemStore.hasLink"
        >{{ itemStore.readMore }}</a
      >
    </div>
  </article>
</template>

<script setup lang="ts">
import { useItemStore } from "@/itemStore";
import type { Item } from "@/itemStore";

const itemStore = useItemStore();

const props = defineProps<{
  item: Item;
  nr: number;
}>();

const showDate = (date: string) => {
  const d = new Date(date);
  return d.toLocaleDateString(itemStore.lang);
};

const getClass = () => {
  let className = "tease";
  className += " tease-" + itemStore.type;
  props.item.primary.forEach((term) => {
    className += " tease-term-" + term.slug;
  });
  className += " tease-nr-" + props.nr;
  return className;
};

const getTerms = () => {
  let terms: string[];
  terms = [];
  props.item.primary.forEach((term) => {
    terms.push(term.name);
  });
  return terms.join(", ");
};

const getImageClass = () => {
  let className = "image-container";
  if (itemStore.imagePostcard) {
    className += " postcard";
  }
  if (props.item.image.medium) {
    className += " has-image";
  } else {
    className += " placeholder";
  }
  return className;
};
</script>
